<template>
	<section :id="['container-' + index + '-' + contactPersonData.type]" :class="['container-' + contactPersonData.type]">
		<div class="container-lg">
			<div class="contact-headline">
				<div class="row justify-content-center">
					<div class="col-sm-12">
						<h2>{{ contactPersonData.config.title }}</h2>
					</div>
				</div>
			</div>
		</div>
		<div class="contact-information" v-for="(contactPerson, index) in contactPersonData.config.addressData"
			:key="index">
			<div class="container-lg">
				<div class="row justify-content-center">
					<div v-if="contactPerson.photoUri" class="contact-image col-sm-12 col-md-6">
						<img :src="`${contactPerson.photoUri}`" alt="">
					</div>
					<div class="col-sm-12 col-md-6 contact-address">
						<div class="contact-name">
							<h3 v-if="contactPerson.firstName || contactPerson.lastName">{{ contactPerson.firstName.value }} {{
								contactPerson.lastName.value
							}}</h3>
						</div>
						<div class="contact-adress" v-if="contactPerson.street || contactPerson.postcode || contactPerson.city">
							<span v-if="contactPerson.street">{{ contactPerson.street.value }}</span> <br
								v-if="contactPerson.street" />
							<span v-if="contactPerson.postcode || contactPerson.city">{{ contactPerson.postcode.value }} {{
								contactPerson.city.value
							}}</span>
						</div>
						<div class="row">
							<div class="col-12 contact-field" v-if="contactPerson.phone">
								<span>Telefon:</span> <span><a :href="`tel:${contactPerson.phone.value}`"> {{
									contactPerson.phone.value
								}}</a></span>
							</div>
							<div class="col-12 contact-field" v-if="contactPerson.mail">
								<span>E-Mail:</span> <span><a :href="`mailto:${contactPerson.mail.value}`"> {{
									contactPerson.mail.value
								}}</a></span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<hr class="horizontal-line">
	</section>
</template>

<script>
export default {
	props: {
		contactPersonData: {
			type: Object
		},
		mainSettings: {
			type: Object
		},
		index: {
			type: Number
		},
	}
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/design-turin/contactPersonComponent.scss";
</style>